module.exports = __webpack_public_path__ + "img/taptab.a42cc3f8.jpg";